class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.ul = this.querySelector("ul");
    this.loader = this.querySelector(".loader-wrapper");
    this.next_url = this.ul.dataset.nextUrl;
    this.scrollLoad = false;
    this.loadingOverlay = document.getElementById("loading-overlay");
    this.loader
      ?.querySelector("[data-load-more]")
      .addEventListener("click", () => {
        this.loadProducts();
      });
  }

  loadProducts() {
    if (this.next_url) {
      this.loader.classList.remove("hidden");
      if (this.loadingOverlay !== null)
        this.loadingOverlay.classList.remove("hidden");
      fetch(this.next_url)
        .then(function (response) {
          return response.text();
        })
        .then(
          function (html) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, "text/html");

            let products = doc.getElementById("product-grid");

            let new_next_url = products.dataset.nextUrl;
            this.next_url = new_next_url;
            this.ul.dataset.nextUrl = this.next_url;
            this.ul.insertAdjacentHTML("beforeend", products.innerHTML);

            if (!new_next_url) {
              this.scrollLoad = true;
              this.loader.classList.add("hidden");
            }
          }.bind(this)
        )
        .catch(function (err) {
          console.warn("Something went wrong.", err);
        })
        .finally(() => {
          if (this.loadingOverlay !== null)
            this.loadingOverlay.classList.add("hidden");
        });
    }
  }
}

customElements.define("product-grid", ProductGrid);

class CollectionFilter extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll("button");
    this.activeClass = "collection-filter__item--active";
    this.ul = document.querySelector("product-grid");
    this.ttl = document.querySelector(".js-dynamic-title");
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get("sort_by");
        let url = button.dataset.url;
        myParam ? (url = url + "?sort_by=" + myParam) : false;
        this.loadProducts(url, button, button.dataset.title);
      });
    });
  }
  loadProducts(url, button, title) {
    if (url) {
      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(
          function (html) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, "text/html");
            // let products = doc.querySelector('product-grid') || doc.querySelector('#product-grid')
            // document.querySelector('product-grid') ? document.querySelector('product-grid').innerHTML = products.innerHTML : document.querySelector('#product-grid').innerHTML = products.innerHTML;
            let newProductGrid =
              doc.querySelector("product-grid") ||
              doc.querySelector("#product-grid");
            let oldProductGrid =
              document.querySelector("product-grid") ||
              document.querySelector("#product-grid");
            oldProductGrid.replaceWith(newProductGrid);
          }.bind(this)
        )
        .catch(function (err) {
          console.warn("Something went wrong.", err);
        })
        .finally(() => {
          this.changeActiveButton(button);
          this.changeUrl(url);
          this.ttl.innerHTML = title;
        });
    }
  }
  changeActiveButton(button) {
    this.buttons.forEach((but) => {
      but.classList.remove(this.activeClass);
    });
    button.classList.add(this.activeClass);
    if (window.innerWidth < 1201) {
      document
        .querySelector("#main-collection-filters")
        .classList.toggle("active");
      document.querySelector("[data-show-filter]").classList.remove("active");
      document.body.classList.remove("rebuy-modal-visible");
      document.querySelector(".filter-backdrop").classList.remove("active");
    }
  }
  changeUrl(url) {
    history.pushState("", "", url);
  }
}
customElements.define("collection-filter", CollectionFilter);

//custom select
var x, i, j, l, ll, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  //a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  a.innerHTML = "Sort by";
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /*for each option in the original select element,
            create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.dataset.value = selElmnt.options[j].value;
    if (selElmnt.options[j].selected) {
      c.classList.add("same-as-selected");
    }

    c.addEventListener("click", function (e) {
      /*when an item is clicked, update the original select box,
                and the selected item:*/
      var y, i, k, s, h, sl, yl, tt;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (tt = 0; tt < sl; tt++) {
        if (s.options[tt].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          //console.log(h, this)
          //h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");

          const opt = selElmnt.querySelector(`[value=${this.dataset.value}]`);
          opt.selected = "selected";
          const form = selElmnt.closest("form");
          form.dispatchEvent(new Event("input", { bubbles: true }));

          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    x[i - 1].classList.toggle("select-arrow-active");
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
    except the current select box:*/
  var z,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  z = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      x[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      z[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
    then close all select boxes:*/

document.getElementById("arrowTrigger").addEventListener("click", function () {
  // Mimic the behavior of when the select-selected element is clicked.
  let selectDiv =
    this.closest(".custom-select").querySelector(".select-selected");
  closeAllSelect(selectDiv);
  selectDiv.nextSibling.classList.toggle("select-hide");
});
